/**
 * Created by hibo on 19/11/18.
 */
import {actions} from '../../actions/todo_list/todo_list';

export default function todoList(initialState = {}, action) {
  const newState = {...initialState};

  switch (action.type) {
    case actions.GET_TODO_LIST: return getTodoListReducer(newState, action);
    case actions.SET_TODO_LIST: return setTodoListReducer(newState, action);
    case actions.UPDATE_TODO_LIST: return updateTodoListReducer(newState, action);
    default:
      return newState;
  }
}

function getTodoListReducer(newState, action) {
  newState.isFetching = action.isFetching;

  return newState;
}

function setTodoListReducer(newState, action) {
  newState.body = [...action.body];
  newState.isFetching = action.isFetching;
  return newState;
}

function updateTodoListReducer(newState, action) {

  newState.updateSuccess = action.success;

  return newState;
}






// WEBPACK FOOTER //
// src/client/reducers/todo_list/todo_list.js